<div class="cardBox mb-20">
  <ion-row class="ion-align-items-center ion-justify-content-start ml-20 pt-20">

     <!-- Year Select -->
     <ion-col size="12" size-sm="3" >
      <mat-form-field class="custom-mat-field mat-height40 mat-input-style w-100">
        <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                    (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
          <mat-option *ngFor="let item of pmsYears" [value]="item.year">
            {{ sharedService.transformYearToFyFormat(item.year) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ion-col>

    <!-- Programme Select -->
    <ion-col size="12" size-sm="3">
      <mat-form-field class="w-100 mat-height40 mat-input-style">
        <mat-select placeholder="Select Programme" >
          <mat-option *ngFor="let program of programType" [value]="program">
            {{ program }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ion-col>
  </ion-row>
  
  <hr style="border: none; height: 1px; background-color: #cccccc8f;" />

  <ion-row class="ion-align-items-center ion-justify-content-between ml-10">
    <ion-col size="12" size-lg="9">
      <ion-row class="ion-align-items-center">
        <!-- Search -->
        <ion-col size="12" size-sm="4" >
          <mat-form-field class="mat-height40 mat-input-style w-100">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
          </mat-form-field>
        </ion-col>
      </ion-row>
    </ion-col>
  
    <ion-col size="12" size-lg="3" >
      <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">    
        <label>
          <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
          <mat-form-field class="w70px mat-height40 mat-input-style">
            <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
              <mat-option [value]="2">2</mat-option>
              <mat-option [value]="25">25</mat-option>
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="75">75</mat-option>
              <mat-option [value]="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
        </label>
        <!-- Download Icon -->
        <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
      </div>
    </ion-col>
  
  </ion-row>
  
  <div class="p-10">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
         
        <div class="table-container">
          <table class="custom-table rounded-header">
             <thead>
              <tr>
                <ng-container *ngFor="let item of tableHeaders">
                  <th *ngIf="item.label !== 'Action'" class="fs-14 font_bold cl-black">
                    <div class="verticle-center justify-content-space-between icon-style">
                      {{ item?.label }}
                    </div>
                  </th>
                </ng-container>
              </tr>
            </thead>
              <tbody class="bg-white">
                <tr *ngFor="let program of getProgrammeForAttendance">
                  <td>{{ program.trainingType }}</td>
                  <td>{{ program.programmeTitle }}</td>
                  <td>{{ program.programmeCode }}</td>
                  <td><a [href]="program.lmsLink" target="_blank">{{program.lmsLink}}</a></td>
                  <td>{{ program.location }}</td>
                  <td>{{ program.startDate }}</td>
                  <td>{{ program.endDate }}</td>
                  <td>{{ program.startTime}}</td>
                  <td>{{ program.endTime}}</td>
                  <td>{{ program.functionalOrBehavioral }}</td>
                  <td>{{ program.department }}</td>
                  <td>{{ program.band }}</td>
                  <td>{{ program.grade }}</td>             
                  <td>{{ program.numberOfProgramDays }}</td>
                  <td>{{ program.budgetCost }}</td>
                  <td>{{ program.actualCost }}</td>
                  <td><a (click)="facultyNamePopup()">{{ program.faculty?.facultyName }}</a></td>
                  <td>{{ program.objective }}</td>
                </tr>
              </tbody>
          </table>
        </div>
        
        
      </ion-col>
    </ion-row>
  </div>


</div>





<!-- ============================= Program attendace ============================== -->
<div class="cardBox mb-20">

 
  <ion-row class="ion-align-items-center ml-20 pt-20">

    <!-- Attendance% -->
    <ion-col size="6" class="d-flex align-items-center">
      <div class="attendance-group" *ngFor="let record of attendanceList">
        <span class="attendance">Attendance: {{ getAttendancePercentage(record.present, record.absent) }}% &nbsp;</span>
        <span class="present">Present: {{ record.present }} &nbsp;</span>
        <span class="absent">Absent: {{ record.absent }}</span>
      </div>
    </ion-col>
  
    <!-- Year and Status Dropdowns -->
    <ion-col size="6">
      <div style="display: flex; justify-content: flex-end; gap: 15px;">
        <!-- Year Select -->
        <mat-form-field class="custom-mat-field mat-height40 mat-input-style m-0" appearance="fill">
          <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                      (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
            <mat-option *ngFor="let item of pmsYears" [value]="item.year">
              {{ sharedService.transformYearToFyFormat(item.year) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
  
        <!-- Status Dropdown -->
        <mat-form-field class="mat-height40 mat-input-style" appearance="fill">
          <mat-select placeholder="Select status">
            <mat-option *ngFor="let program of programList" [value]="program">
              {{ program }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </ion-col>
  
  </ion-row>
  
  <hr style="border: none; height: 1px; background-color: #cccccc8f;"/>


  <ion-row class="ion-align-items-center ion-justify-content-between ml-20">
    <ion-col size="12" size-lg="9">
      <ion-row class="ion-align-items-center">
      <!-- Search -->
        <ion-col size="12" size-sm="4" class="mb-16">
          <mat-form-field class="mat-height40 mat-input-style w-100">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
          </mat-form-field>
        </ion-col>
        <!-- Approve / Reject -->
        <ion-col size="12" size-sm="4" class="mb-16" style="display: flex; gap: 10px;"  *ngIf="isAnySelected">
          <button type="button" class="add_btnn present-btn" (click)="presentSelected()">Present</button>
          <button type="button" class="add_btnn absent-btn" (click)="absentSelected()">Absent</button>
        </ion-col> 
      </ion-row>
    </ion-col>
  
    <ion-col size="12" size-lg="3" class="mb-16">
      <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">      
        <label>
          <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
          <mat-form-field class="w70px mat-height40 mat-input-style">
            <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
              <mat-option [value]="2">2</mat-option>
              <mat-option [value]="25">25</mat-option>
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="75">75</mat-option>
              <mat-option [value]="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
        </label>
  
        <!-- Download Icon -->
        <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
  
      </div>
    </ion-col>
  
  </ion-row>
  

 
  
  <div class="p-10">
    <ion-row>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="table-container">
          <table class="custom-table rounded-header">
            <thead>
              <tr>
                <th class="fs-14 font_bold cl-black">
                  <mat-checkbox  color="primary" (change)="selectAll($event)"></mat-checkbox>
                </th>
                <th *ngFor="let item of employeeTableHeaders" class="fs-14 font_bold cl-black">
                  <div class="verticle-center justify-content-space-between icon-style">
                    {{ item?.label }}
                  </div>
                </th>
              </tr>
            </thead>
        
            <tbody class="bg-white">
              <tr *ngFor="let program of employeeTrainingPrograms">
                <td>
                  <mat-checkbox  color="primary" [(ngModel)]="program.selected"  (change)="updateSelectionStatus()"></mat-checkbox>
                </td>
                <td>{{ program.code }}</td>
                <td>{{ program.name }}</td>
                <td>{{ program.department }}</td>
                <td>{{ program.band }}</td>
                <td>{{ program.grade }}</td>
                      
                <td>
                  <div class="status-button-group" >
                    <button
                      type="button"
                      class="status-button approved"
                      [class.active]="program.status === 'Approved'"
                      (click)="program.status = 'Approved'"
                    >
                  Present
                    </button>
                  
                    <button
                      type="button"
                      class="status-button rejected"
                      [class.active]="program.status === 'Rejected'"
                      (click)="program.status = 'Rejected'"
                    >
                     Absent
                    </button>
                  </div>
                  </td>
                
              </tr>
            </tbody>
          </table>
        </div>
        
        
        
      </ion-col>
    </ion-row>
  </div>
</div>



